import useTranslate from "../../../../modules/local/useTranslate";
import {useState} from "react";
import {notifyOnError} from "../../factory/createErrorEvent";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {
    course_class_acceptAbsenceRequest_Api,
    course_class_cancelAbsenceRequest_Api,
    course_class_createAbsenceRequest_Api,
    course_class_rejectAbsenceRequest_Api
} from "../../../../apis";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import {NullAsDefault} from "../../../Shared";


export const useCourseClassAbsenceRequestApi = ({
                                                    notifyListeners = {
                                                        onSuccess: undefined,
                                                    },
                                                }) => {
    const t = useTranslate()

    const [refresh_token, set_refresh_token] = useState()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const onRefresh = () => {
        onCancel()
        set_refresh_token(Date.now())
    }

    const {
        onSuccess = NullAsDefault,
    } = notifyListeners ?? {}
    const onError = notifyOnError(t)

    const {handleAsyncAction: createAbsenceRequest, ...creatingAbsenceRequestAsync} = useAsyncAction({
        onError,
        apiInfo: course_class_createAbsenceRequest_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
            onSuccess(result, data)
        },
    })

    const {handleAsyncAction: cancelAbsenceRequest, ...cancelingAbsenceRequestAsync} = useAsyncAction({
        onError,
        apiInfo: course_class_cancelAbsenceRequest_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onCancel()
            onSuccess()
        },
    })

    const {handleAsyncAction: acceptAbsenceRequest, ...acceptingAbsenceRequestAsync} = useAsyncAction({
        onError,
        apiInfo: course_class_acceptAbsenceRequest_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onRefresh()
            onSuccess()
        },
    })

    const {handleAsyncAction: rejectAbsenceRequest, ...rejectingAbsenceRequestAsync} = useAsyncAction({
        onError,
        apiInfo: course_class_rejectAbsenceRequest_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onRefresh()
            onSuccess()
        },
    })

    return {
        createAbsenceRequest,creatingAbsenceRequestAsync,
        cancelAbsenceRequest,cancelingAbsenceRequestAsync,
        acceptAbsenceRequest,acceptingAbsenceRequestAsync,
        rejectAbsenceRequest,rejectingAbsenceRequestAsync
    }
}